<div class="login-wrapper">
  <div class="content-wrapper">
    <h1>kis portás Admin</h1>
    <div class="form-wrapper">
      <form (submit)="signIn()" #loginForm="ngForm">
        <custom-input
          [type]="'email'"
          [name]="'username'"
          label="Felhasználónév"
          [required]="true"
          [(ngModel)]="loginGroup.username"
        />

        <br />
        <custom-input
          [type]="'password'"
          [name]="'password'"
          [required]="true"
          [(ngModel)]="loginGroup.password"
          label="Jelszó"
        />

        <br />
        <button
          class="primary-button"
          type="submit"
          [disabled]="loginForm.invalid"
        >
          <span *ngIf="!isLoading">Belépés</span>
          <app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
        </button>
      </form>
    </div>
  </div>
  <!-- <div class="version"><span>v</span>TODO</div> -->
</div>
